import { NoticeExtractorLawFirmResponseDto } from 'app/API';
import { DataRows } from '../DataRows';

type TProps = {
  lawFirms?: NoticeExtractorLawFirmResponseDto[];
};

export function LawFirmsCard({ lawFirms = [] }: TProps) {
  return (
    <section className="col-span-full min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Law firms</h3>
      {lawFirms.length ? (
        <div className="grid gap-2.5">
          {lawFirms.map((firm, index) => (
            <div
              className="rounded-lg border border-border bg-surface-muted p-2.5"
              key={`${firm.firm_name ?? 'firm'}-${index}`}
            >
              <DataRows
                rows={[
                  { label: 'Firm name', value: firm.firm_name },
                  { label: 'Representing', value: firm.representing },
                  { label: 'Attorneys', value: firm.attorneys?.map((attorney) => attorney.name ?? '').filter(Boolean) },
                  { label: 'Address', value: firm.address },
                  { label: 'Phone', value: firm.phone },
                  { label: 'Fax', value: firm.fax },
                  { label: 'Email', value: firm.email },
                ]}
              />
            </div>
          ))}
        </div>
      ) : (
        <span className="text-xs leading-[18px] text-foreground-muted">No law firms found</span>
      )}
    </section>
  );
}
